import { BrowseMoreJobsButton } from "../BrowseMoreJobsButton";

export function RecruiterScreeningCallMeNowConfirmationActions() {
  return <BrowseMoreJobsButton />;
}
